export default __webpack_public_path__ + "static/media/079-house-1.9431a7c6.svg";